module.exports = __webpack_public_path__ + "static/media/home.c213dcb5.png";